import React, { useState } from "react";
import List from "../expeditionProcessList";
import Filter from "../expeditionProcessFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import Breadcrumb from "../../../utils/breadCrumbs";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import * as XLSX from "xlsx";
import { useExpedition } from "../hook/useExpedition";
import ShowDialog from "../../../utils/ShowDialog/ShowDialog";
import * as InventaryService from "../../../../services/InventaryService";
import showDialog from "../../../utils/ShowDialog/ShowDialog";

const queryClient = new QueryClient();

const StockFilterListContainer = (props) => {
  const { t } = useTranslation();
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.expeditionProcess.title") },
  ];

  const [filters, setFilters] = useState(undefined);
  const [refresh, setRefresh] = useState(false);

  const { newExpedition } = useExpedition(() => setRefresh(true));
  const navigate = useNavigate();

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters(undefined);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    setFilters(newFilter);
  };

  const handlerOnCancel = () => {
    navigate(PATHS.INVENTARY_LIST);
  };

  const onNewProcess = async (uuid, serviceType, crop) => {
    let title = t("forms.inventary.dialog.newProcess.title");
    let text = t("forms.inventary.dialog.newProcess.text");

    let okAction = async () => {
      try {
        const result = await InventaryService.newInventary();

        let title = "";
        let text = "";
        let icon = "";

        if (result) {
          title = t("forms.inventary.messages.createProcess.title");
          text = t("forms.inventary.messages.createProcess.success");
          icon = "success";
          setRefresh(true);
        } else {
          title = "Error";
          text = t("forms.inventary.messages.createProcess.error");
          icon = "error";
        }

        showDialog(title, text, icon, false, "OK", false);
      } catch (error) {
        const errorCode = error.data.error.code;
        let errorMsg;
        if (errorCode === "INVENTARY.OPEN_YET") {
          errorMsg = t("forms.inventary.messages.createProcess.openYet");
        } else {
          errorMsg = t("forms.inventary.messages.createProcess.error");
        }

        showDialog("Error", errorMsg, "error", false, "OK", false);
      }
    };

    const cancelAction = () => {};

    ShowDialog(
      title,
      text,
      "warning",
      true,
      t("forms.inventary.dialog.newProcess.buttonOk"),
      false,
      okAction,
      t("forms.inventary.dialog.newProcess.buttonNo"),
      cancelAction
    );
  };

  return (
    <>
      <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.expeditionProcess.title")}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
          />
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List
              refresh={refresh}
              className="marg-top-1rem"
              filters={filters}
              onRefreshComplete={() => setRefresh(false)}
            />
          </QueryClientProvider>
        </div>
      </div>
      <Can do={USER_PERMISSIONS.EXPORT_MOVE}>
        <div className="row justify-content-center mt-4 mb-5">
          <div className="col-12 col-md-11 text-center">
            <button
              type="button"
              className="btn btn-lg btn-secondary"
              onClick={() => newExpedition()}
            >
              <i className="fa-solid fa-box-archive icon-button"></i>{" "}
              {t("forms.expeditionProcess.buttons.createProcess")}
            </button>
          </div>
        </div>
      </Can>
    </>
  );
};

StockFilterListContainer.propTypes = {};

export default StockFilterListContainer;
